import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { CTAButton } from './CTAButton';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-4 py-12 sm:px-6 sm:py-16" data-id="element-102" data-mp="1ceqetqsvt3iv">
      <div className="mx-auto max-w-2xl" data-id="element-103" data-mp="1ccdpgsksnqvs">
        <h2 className="text-center font-serif text-[27px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-104" data-mp="2a2ic0krxw4qg">
          Preguntas frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-105" data-mp="2512u31l26eca">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-navy-100 bg-white shadow-card" data-id="element-106" data-mp="1v5r9w3qvsex5" data-mpi={index}>
                <h3 data-id="element-107" data-mp="jpswxosl18qn">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-108" data-mp="jpjgosxcafy5">
                    <span className="text-[15px] font-bold leading-snug text-navy-900" data-id="element-109" data-mp="1aq2bhsm6ei3d">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-110" data-mp="1fmsrkfxzddos" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-111" data-mp="rx869qecu4cc">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: 'easeOut'
              }} data-id="element-112" data-mp="ww1lpod7c5f5">
                      <p className="px-4 pb-4 text-[14px] leading-relaxed text-navy-900/80" data-id="element-113" data-mp="2poq4l8bj33i2">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-114" data-mp="2avnyytb4hlk9">
          <CTAButton label="Resolver mis dudas con la Ruta" note="Pago único · Acceso de por vida" data-id="element-115" data-mp="38lr9yu8zv5mj" />
        </div>
      </div>
    </section>;
}